// extracted by mini-css-extract-plugin
module.exports = {"component":"Navbar_component__6-lvK","iconLink":"Navbar_iconLink__3zoP8","cartLink":"Navbar_cartLink__XkKcu"};